import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const NavList = styled.ul`
  display: grid;
  place-items: center;
  grid-template-columns: repeat(6, auto);
  padding: 0;
  margin: 0;
  column-gap: ${rem('24px')};

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    width: 100%;
    height: 100%;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, auto);
    align-items: center;
    row-gap: ${rem('40px')};
    margin: 0;
  }
`;

export const NavItem = styled.li`
  list-style: none;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  letter-spacing: 0.5px;

  ${({ $active }) =>
    $active &&
    css`
      font-weight: 700;
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.colors.gradientStart} 0%,
        ${({ theme }) => theme.colors.gradientEnd} 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;

      ::after {
        content: '';
        width: 100%;
        height: ${rem('3px')};
        background: linear-gradient(
          135deg,
          ${({ theme }) => theme.colors.gradientStart} 0%,
          ${({ theme }) => theme.colors.gradientEnd} 100%
        );
        position: absolute;
        bottom: -8px;
        left: 0;
        border-radius: 2px;
      }
    `}

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(
      135deg,
      ${({ theme }) => theme.colors.gradientStart} 0%,
      ${({ theme }) => theme.colors.gradientEnd} 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;
